import { useUserPreference } from '@/admin/hooks/use-user-preference'

/**
 * Pin my view for a page of draggable cards: whether the user pinned their
 * arrangement, and whether they have seen the arrange tip. Per user, per page,
 * server-backed. Render it with `<PinMyViewBar>` and pass `pinned` to
 * DraggableCardGrid's `locked`.
 */
export type PinnedView = {
  pinned: boolean
  hintSeen: boolean
  togglePin: () => void
  dismissHint: () => void
}

export function usePinnedView(page: string): PinnedView {
  const pinned = useUserPreference<boolean>(`${page}-cards-pinned`, false)
  const hintSeen = useUserPreference<boolean>(`${page}-cards-hint-seen`, false)
  return {
    pinned: pinned.value,
    hintSeen: hintSeen.value,
    togglePin: () => {
      // Pinning proves they found the feature, so the tip retires too.
      hintSeen.setValue(true)
      pinned.setValue(!pinned.value)
    },
    dismissHint: () => hintSeen.setValue(true),
  }
}
